import { render, staticRenderFns } from "./createLeave.vue?vue&type=template&id=18a6075a&scoped=true&"
import script from "./createLeave.vue?vue&type=script&lang=js&"
export * from "./createLeave.vue?vue&type=script&lang=js&"
import style0 from "./createLeave.vue?vue&type=style&index=0&id=18a6075a&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a6075a",
  null
  
)

export default component.exports